import React, { useState, useEffect } from "react";
import { db } from "../firebase"; // Adjust path to your Firebase configuration
import { collection, onSnapshot } from "firebase/firestore";

const SearchHistory = () => {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    // Real-time listener for search history data from Firestore
    const unsubscribe = onSnapshot(collection(db, "searchHistory"), (snapshot) => {
      const historyData = snapshot.docs.map((doc) => doc.data().searchTerm);
      setHistory(historyData);
    });

    // Cleanup the listener when the component unmounts
    return () => unsubscribe();
  }, []); // Empty dependency array ensures this runs once when the component mounts

  return (
    <div style={{ padding: "20px" }}>
      <h2>User Search History</h2>
      {history.length === 0 ? (
        <p>No search history available.</p>
      ) : (
        <ul>
          {history.map((entry, index) => (
            <li key={index}>{entry}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchHistory;
